import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react';
import FrontPage from './components/FrontPage';
import SignInPage from './components/SignIn';
import SignUpPage from './components/SignUp';
import MainMenu from './components/MainMenu';
import CreateNewCup from './components/CreateNewCup';
import CurrentEvents from './components/CurrentEvents';
import MyStats from './components/MyStats';
import Players from './components/Players';
import EventDetails from './components/EventDetails';
import EnterScores from './components/EnterScores';
import LeaderboardPage from './components/LeaderboardPage';
import SettingsPage from './components/SettingsPage';
import LevelAndUserButton from './components/LevelAndUserButton';
import NavBar from './components/NavBar';

function AppContent() {
  const location = useLocation();
  // Hide on enter-scores route
  const hideLevelAndUserButton =
      location.pathname.startsWith('/sign-in') ||
      location.pathname.startsWith('/sign-up') ||
      location.pathname.startsWith('/event/') && location.pathname.endsWith('/enter-scores');

   // Hide NavBar on '/' and '/event/:eventId/enter-scores'
  const hideNavBar =
      location.pathname.startsWith('/event/') && location.pathname.endsWith('/enter-scores');


  return (
    <>
      {!hideLevelAndUserButton && (
        <SignedIn>
          <LevelAndUserButton />
        </SignedIn>
      )}
      <SignedIn>
        {!hideNavBar && <NavBar />}
      </SignedIn>
      <Routes>
        <Route path="/sign-in" element={<SignInPage />} />
        <Route path="/sign-up" element={<SignUpPage />} />
        <Route
          path="/"
          element={
            <>
              <SignedIn> 
                <MainMenu />
              </SignedIn>
              <SignedOut>
                <FrontPage />
              </SignedOut>
            </>
          }
        />
        <Route
          path="/create-new-cup"
          element={
            <>
              <SignedIn>
                <NavBar />
                <CreateNewCup />
              </SignedIn>
              <SignedOut>
                <RedirectToSignIn />
              </SignedOut>
            </>
          }
        />
        <Route
          path="/current-events"
          element={
            <>
              <SignedIn>
                <CurrentEvents />
              </SignedIn>
              <SignedOut>
                <RedirectToSignIn />
              </SignedOut>
            </>
          }
        />
        <Route
          path="/my-stats"
          element={
            <>
              <SignedIn>
                <MyStats />
              </SignedIn>
              <SignedOut>
                <RedirectToSignIn />
              </SignedOut>
            </>
          }
        />
        <Route
          path="/players"
          element={
            <>
              <SignedIn>
                <Players />
              </SignedIn>
              <SignedOut>
                <RedirectToSignIn />
              </SignedOut>
            </>
          }
        />
        <Route
            path="/event/:eventId"
            element={
              <>
                <SignedIn>
                  <EventDetails />
                </SignedIn>
                <SignedOut>
                  <RedirectToSignIn />
                </SignedOut>
              </>
            }
          />
          <Route
            path="/event/:eventId/enter-scores"
            element={
              <>
                <SignedIn>
                  <EnterScores />
                </SignedIn>
                <SignedOut>
                  <RedirectToSignIn />
                </SignedOut>
              </>
            }
          />
          <Route
          path="/event/:eventId/leaderboard"
          element={
            <>
              <SignedIn>
                <LeaderboardPage />
              </SignedIn>
              <SignedOut>
                <RedirectToSignIn />
              </SignedOut>
            </>
          }
        />
        <Route
          path="/settings"
          element={
            <>
              <SignedIn>
                <SettingsPage />
              </SignedIn>
              <SignedOut>
                <RedirectToSignIn />
              </SignedOut>
            </>
          }
        />
        <Route
          path="*"
          element={
            <SignedOut>
              <RedirectToSignIn />
            </SignedOut>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;